import { createAction, handleActions } from 'redux-actions';
import { from, of } from 'rxjs';
import { filter, mergeMap, catchError } from 'rxjs/operators';
import { CryptoUtils } from '../../utils/cryptoUtils';
import { getUserId, getUserSecret } from '../account/userData';
import _ from 'lodash';
import { logout, onForbidden } from '../account/login';
import { fetchSubmitFormFailed, fetchSubmitForm, resetSubmitFormData } from '../common/submitForm';
import { Api } from '../../api/api';
import { StorageApi } from '../../utils/storageApi';
import { addNotificationData } from '../common/notifications';
import { NOTIFICATION_TYPES } from '../../constants/constants';

//- Actions
export const fetchGetKeyFailed = createAction('FETCH_GET_KEY_FAILED');
export const fetchGetKeySuccess = createAction('FETCH_GET_KEY_SUCCESS');
export const onFetchGetKeySuccess = (key) => (dispatch) => {
    dispatch(addNotificationData({ type: NOTIFICATION_TYPES.INSERTER_SECURITY_NO_CERTIFICATE, value: _.isNil(key) ? 1 : 0 }));
    dispatch(fetchGetKeySuccess(key));
}
export const fetchGetKey = () => (dispatch, getState) => {
    let userId = getUserId(getState());
    let userSecret = getUserSecret(getState());
    dispatch(onGetKey(userId, userSecret));
}
export const onGetKey = createAction(
    'FETCH_GET_KEY',
    (userId, secret) => CryptoUtils.getKey(userId, secret),
    () => ({
        cryptoCall: true,
        onSuccess: onFetchGetKeySuccess,
        onFail: fetchGetKeyFailed,
    })
);
    
export const fetchSubmitFormFailedIncorrectJWK = (error) => (dispatch) => {
    dispatch(fetchSubmitFormFailed("INCORRECT_JWK"));
}

export const fetchSetJWK = createAction('FETCH_SET_JWK');

export const fetchPutKey = (jwk) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchSetJWK(jwk));
    let token = StorageApi.getLoginToken();
    dispatch(fetchSignToken(jwk, token));
}

export const fetchSignToken = createAction(
    'FETCH_SIGN_TOKEN',
    (jwk, token) => CryptoUtils.signStringWithJWK(jwk, token),
    () => ({
        cryptoCall: true,
        onSuccess: fetchVerifyJWK,
        onFail: fetchSubmitFormFailedIncorrectJWK,
    })
);

export const fetchVerifyJWK = createAction(
    'FETCH_VERIFY_JWK',
    (data) => Api.verifyJWK({ signature: data }),
    () => ({
        apiCall: true,
        onSuccess: onVerifyJWKSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const onVerifyJWKSuccess = (result) => (dispatch, getState) => {
    if (result.passed) {
        let userId = getUserId(getState());
        let userSecret = getUserSecret(getState());
        let jwk = getJWK(getState());
    
        dispatch(onPutKey(userId, jwk, userSecret));
    } else {
        dispatch(fetchSubmitFormFailed("INCORRECT_JWK"));
    }
}

export const onPutKey = createAction(
    'FETCH_PUT_KEY',
    (userId, jwk, secret) => CryptoUtils.putKey(userId, jwk, secret),
    () => ({
        cryptoCall: true,
        onSuccess: onPutKeySuccess,
        onFail: fetchSubmitFormFailedIncorrectJWK,
    })
);
export const onPutKeySuccess = (key) => (dispatch) => {
    dispatch(fetchSetKey(key));
    dispatch(resetSubmitFormData());
}

export const fetchSetKey = createAction('FETCH_SET_KEY');

//- State
const initialState = {
    key: null,
    jwk: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({

    FETCH_GET_KEY: (state) => {
        return { ...state, key: null, error: null, fetching: true };
    },
    FETCH_GET_KEY_FAILED: (state, action) => {
        return { ...state, key: null, error: action.payload, fetching: false };
    },
    FETCH_GET_KEY_SUCCESS: (state, action) => {
        return { ...state, key: action.payload, error: null, fetching: false };
    },
    FETCH_SET_KEY: (state, action) => {
        return { ...state, key: action.payload };
    },
    FETCH_SET_JWK: (state, action) => {
        return { ...state, jwk: action.payload };
    }

}, initialState);

//- Epics
export const handleCryptoEpic = (action$) => {
    return action$.pipe(
        filter(action => !_.isNil(action.meta) && action.meta.cryptoCall),
        mergeMap(action => {
            return from(action.payload).pipe(
                mergeMap(data => {
                    return of(action.meta.onSuccess(data));
                }),
                catchError(error => {
                    return of(
                        action.meta.onFail(error.message)
                    )
                })
            )
        })
    );
};

//- Selectors
export const getCertificate = state => state.certificate;

export const getKey = state => getCertificate(state).key;

export const getJWK = state => getCertificate(state).jwk;

export const getKeyLoading = state => getCertificate(state).fetching;

export const getKeyError = state => getCertificate(state).error;


// WEBPACK FOOTER //
// ./src/reducers/accreditation/certificate.js